import React,{ useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CancelTurno, getCard, getMyTurnos, pagarTurno } from '../actions';
import { Link } from 'react-router-dom';
import NavBar from '../components/Home/NavBar';
import Swal from 'sweetalert2'
import Modal from 'react-modal';

const Misturnos = () => {
  const dispatch = useDispatch()

  const [cancelado, setCancelado] = useState(false); // estado local para actualizar lista de turnos
  const misTurnos = useSelector((state: any) => state.userTurnos);
  const token= localStorage.getItem('token')
  const [visible, setIsVisible] = useState(false)


  useEffect(() => {
    if(token){
      dispatch(getMyTurnos(token));
    }
    setCancelado(false); // resetear estado local al actualizar lista de turnos
  }, [cancelado, dispatch]); // volver a llamar useEffect cuando cambie el estado local

  // const link = useSelector((state : any) => state.linkPago)
  const handleCancelarTurno = (id:number) => {
    Swal.fire({
      title: '¿Estás seguro de querer cancelar tu turno?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(CancelTurno(id));
        setCancelado(true); // actualizar estado local después de cancelar el turno
      }
    })
  }

  // useEffect(() => {
  //   if(link) {
  //     handleDelay();
  //   }
  // }, [link])

  
//  const handleDelay = async () => {
//   if(link){

//     Swal.fire({
//       title: 'Queres pagar la consulta ahora?',
//       icon: 'question',
//       showCancelButton: true,
//       confirmButtonColor: '#2A824D',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Si',
//       cancelButtonText:'En otro momento'
//     }).then((result:any) => {
//       if(result.isConfirmed) {
//         console.log('link',link)
//         window.location.href = link  }
//       })
//     }
//  }
const handleModalClose = (): void => {
  setIsVisible(false);
};

  const handlePago = async (e:any) => {
   e.preventDefault()
   dispatch(getCard())
   setIsVisible(true)
}


   const tarjeta = useSelector((state: any) => state.tarjeta)

  
  
   const now = new Date() // obtener fecha y hora actual
  return (
    <div className="flex flex-col items-center justify-center">
      <NavBar />
   {token ? <div className="flex flex-col items-center justify-center">
      <h1 className='font-roboto text-[22px] sm:text-[32px]'>MIS TURNOS</h1>

<table className="table-fixed mt-8 text-[10px] sm:text-[20px] w-11/12">

  <thead className="bg-background_home text-white">
    <tr>
      <th className="w-1/5 py-2">Doctor/a</th>
      <th className="w-1/5 py-2">Fecha</th>
      <th className="w-1/5 py-2">Horario</th>
      <th className="w-1/5 py-2">Estado</th>
      <th className="w-1/5 py-2">Asistencia</th>
      <th className="w-1/5 py-2">Pago</th>
      <th className="w-1/5 py-2">Acciones</th>
    </tr>
  </thead>
  <tbody className="text-center font-roboto bg-white border">
    {misTurnos.map((m:any,index:number)=>{
      // comprobar si el turno ya pasó
      const [day, month, year] = m.date.split('/');
        const dateAndTime = new Date(`${month}/${day}/${year} ${m.initTime}`);
        const turnoPasado = dateAndTime.getTime() < now.getTime();
      
      return (
        <tr key={index} className="border-b">
          <td className="py-2">{m.calendar.name}</td>
          <td className="py-2">{m.date}</td>
          <td className="py-2">{m.initTime} - {m.endTime}</td>
          <td className="py-2">{turnoPasado ? 'Expirado' : 'Activo'}</td>
          <td className="py-2">{m.status}</td>
          <td className="py-2">
          {m.paymentStatus === 'Pendiente de Pago' ?
          <div> 
            <button onClick={handlePago} className="bg-background_home text-white flex justify-center items-center 
          sm:inline-block font-medium  text-[8px] w-8 h-8 px-4 sm:text-[13px] sm:mb-0 mb-2 sm:w-24 sm:h-10 rounded ml-2 sm:ml-0">
          Realizar pago</button>
          
          <Link to={`/comprobante/${m.id}`}> <button className="bg-indigo-600 text-white flex justify-center items-center 
          sm:inline-block font-medium  text-[7px] w-8 h-8 px-4 sm:text-[13px] sm:w-24 sm:h-10 rounded ml-2 sm:ml-0">Subir comprobante</button> </Link></div>  
          
          :
          'Realizado' }    
          </td>
         
          <td className="py-2">
            {turnoPasado ? '-' : (
              <button onClick={()=>handleCancelarTurno(m.id)} className="bg-red-500 flex justify-center items-center sm:inline-block hover:bg-red-700 text-white 
              font-medium text-[10px] w-12 h-10 px-4 sm:text-[13px] sm:w-24 rounded">
                Cancelar Turno
              </button>
            )}
          </td>
        </tr>
      )
    })}
  </tbody>
</table>

<Modal
  className='w-4/5 sm:w-2/4 bg-white font-roboto'
  isOpen={visible}
  onRequestClose={handleModalClose}
  style={{
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      position: 'relative',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      border: 'none',
      borderRadius: '10px',
      padding: '20px',
      maxWidth: '90%',
      maxHeight: '90%',
    },
  }}
>
<div className='flex flex-col justify-center items-center'>
<h1 className='text-[28px] font-roboto'>Realiza la transferencia a esta cuenta</h1>

<table className="table-fixed mt-8 text-[10px] sm:text-[20px]">

  <thead className="bg-background_home text-white">
    <tr>
      <th className="w-1/4  border-2  py-2">Titular</th>
      <th className="w-1/4  border-2  py-2">Cbu/Cvu</th>
      <th className="w-1/4   border-2  py-2">Cuil/Cuit</th>
      <th className="w-1/4  border-2  py-2">Banco</th>
    </tr>
  </thead>

   <tbody className="text-center font-roboto bg-white border">
    <tr className="border-b">
     <td className="py-2 border-2 ">{tarjeta.card && tarjeta.card.titular}</td>
     <td className="py-2  border-2 ">{tarjeta.card && tarjeta.card.cvu}</td>
     <td className="py-2 border-2  ">{tarjeta.card && tarjeta.card.cuit}</td>
     <td className="py-2  border-2 ">{tarjeta.card && tarjeta.card.banco}</td>
    </tr>
   </tbody> 
</table>
</div>

</Modal>

 </div> 
     
     : <p className='font-roboto text-[24px]'>Debes iniciar Sesion para poder utilizar esta ventana</p>}
   
    </div>
  )
}

export default Misturnos